import React, { useEffect } from "react";
import "./Education.css";
import {
  FaCalendar,
  FaMapMarker,
  FaAward,
  FaBook,
  FaSchool,
  FaUniversity,
} from "react-icons/fa";

const Education = () => {
  const educationData = [
    {
      id: 1,
      degree: "Bachelor of Science in Computer Engineering",
      institution: "Pragati Engineering College",
      location: "Surampalem, Kakinada",
      period: "2024 - 2027",
      gpa: "7.5/10.0",
      description:
        "Focused on software engineering, machine learning, and embedded systems.",
      courses: ["Data science and engineering"],
      icon: <FaUniversity />,
    },
    {
      id: 2,
      degree: "Diploma",
      institution: "smt.B.Seetha polytechnic",
      location: "Bhimavaram, Andhra Pradesh",
      period: "2020 - 2024",
      gpa: "7.5/10.0",
      description: "Graduated with highest honors. AP Scholar with Distinction.",
      courses: ["Data science and engineering"],
      icon: <FaSchool />,
    },
  ];
  

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".edu-card").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="education">
      <div className="container">
        <div className="section-header">
          <span className="badge">📚 Education</span>
          <h1>My Education</h1>
          <p>My academic journey and achievements</p>
        </div>

        {/* Education Cards */}
        <div className="edu-grid">
          {educationData.map((edu) => (
            <div className="edu-card" key={edu.id}>
              <div className="edu-icon">{edu.icon}</div>
              <div className="edu-body">
                <h3>{edu.degree}</h3>
                <h4>{edu.institution}</h4>
                <div className="edu-meta">
                  <span>
                    <FaMapMarker /> {edu.location}
                  </span>
                  <span>
                    <FaCalendar /> {edu.period}
                  </span>
                  <span className="gpa">
                    <FaAward /> GPA: {edu.gpa}
                  </span>
                </div>
                <p className="edu-desc">{edu.description}</p>
                <div className="edu-courses">
                  <strong>
                    <FaBook /> Courses:
                  </strong>
                  <div className="course-list">
                    {edu.courses.map((course, i) => (
                      <span key={i}>{course}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;